/**
 * Bilder ur urklipp — delad hjälp för kommentarsrutor.
 *
 * Mönstret satt inbakat i ProjekteringKanbans granskningsmodal, så BK kunde
 * klistra in skärmbilder i sin granskning medan IA:s svarsruta i Att göra-fliken
 * bara tog text. Backend tog emot bilder från början; det var frontenden som
 * saknade halvan. Ligger här så nästa kommentarsruta inte hamnar i samma läge.
 */

// Backend tar emot max 5 filer per kommentar (reviewUpload.array('images', 5)).
export const MAX_BILDER = 5;

/**
 * Plocka ut bildfiler ur en paste-händelse.
 *
 * Returnerar tom lista när urklippet inte innehåller bilder — anroparen ska då
 * INTE anropa preventDefault, annars går vanlig textinklistring förlorad.
 *
 * @param {ClipboardEvent} e
 * @returns {File[]}
 */
export const bilderFranUrklipp = (e) => {
  const items = e.clipboardData?.items;
  if (!items) return [];

  const filer = [];
  for (let i = 0; i < items.length; i++) {
    if (!items[i].type?.startsWith('image/')) continue;
    const fil = items[i].getAsFile();
    if (fil) filer.push(fil);
  }
  return filer;
};

/**
 * Färdig onPaste-hanterare. Lägger till inklistrade bilder i state och kapar
 * vid MAX_BILDER så att servern aldrig avvisar hela kommentaren.
 *
 * @param {Function} setBilder - state-setter som tar en updater
 * @returns {Function} onPaste-hanterare
 */
export const skapaPasteHanterare = (setBilder) => (e) => {
  const nya = bilderFranUrklipp(e);
  if (nya.length === 0) return;
  e.preventDefault();
  setBilder(prev => [...prev, ...nya].slice(0, MAX_BILDER));
};
